import { withSentryReactRouterV6Routing } from '@sentry/react';
import React, { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { routes } from '../../../routes';
import AssignTicket from '../AssignTicket/AssignTicket';
import AutoAssignServiceAccounts from '../AutoAssignServiceAccounts/AutoAssignServiceAccounts';
import Companies from '../Companies/Companies';
import CompanyDetails from '../CompanyDetails/CompanyDetails';
import ErrorIndex from '../ErrorIndex/ErrorIndex';
import Home from '../Home/Home';
import PageNotFound from '../PageNotFound/PageNotFound';
import ProductDetails from '../ProductDetails/ProductDetails';
import Products from '../Products/Products';
import ReassignTicket from '../ReassignTicket/ReassignTicket';
import ServiceAccountDetails from '../ServiceAccountDetails/ServiceAccountDetails';
import ServiceAccounts from '../ServiceAccounts/ServiceAccounts';
import Settings from '../Settings/Settings';
import TicketDetails from '../TicketDetails/TicketDetails';
import Tickets from '../Tickets/Tickets';

const ManufacturerRouter: FC = () => {
  const SentryRoutes = withSentryReactRouterV6Routing(Routes);

  return (
    <SentryRoutes>
      <Route path={routes.HOME} element={<Home />} />
      <Route path={routes.SERVICE_ACCOUNTS} element={<ServiceAccounts />} />
      <Route
        path={routes.NEW_SERVICE_ACCOUNT}
        element={<ServiceAccountDetails />}
      />
      <Route
        path={`${routes.EDIT_SERVICE_ACCOUNT}/:serviceId`}
        element={<ServiceAccountDetails edit />}
      />
      <Route path={routes.COMPANIES} element={<Companies />} />
      <Route path={routes.NEW_COMPANY} element={<CompanyDetails />} />
      <Route
        path={`${routes.EDIT_COMPANY}/:companyId`}
        element={<CompanyDetails edit />}
      />
      <Route
        path={routes.AUTO_ASSIGN}
        element={<AutoAssignServiceAccounts />}
      />
      <Route path={routes.TICKETS} element={<Tickets />} />
      <Route path={routes.TICKET_DETAILS} element={<TicketDetails />} />
      <Route
        path={`${routes.TICKET_DETAILS}${routes.ASSIGN}`}
        element={<AssignTicket />}
      />
      <Route
        path={`${routes.TICKET_DETAILS}${routes.REASSIGN}`}
        element={<ReassignTicket />}
      />
      <Route path={routes.PRODUCTS} element={<Products />} />
      <Route path={routes.ADD_PRODUCT} element={<ProductDetails />} />
      <Route
        path={`${routes.EDIT_PRODUCT}/:productId`}
        element={<ProductDetails edit />}
      />
      <Route path={routes.ERROR_INDEX} element={<ErrorIndex />} />
      <Route path={routes.SETTINGS} element={<Settings />} />
      <Route path={routes.PAGE_NOT_FOUND} element={<PageNotFound />} />
      <Route path={'*'} element={<Navigate to={routes.HOME} />} />
    </SentryRoutes>
  );
};

export default ManufacturerRouter;
